<template lang="pug">
section
  .head
    h1 樂台計畫金流服務條款
  p 【金流服務】是與第三方支付公司綠界科技 EC Pay 合作，利用系統自動化代收報名費用方式，降低人工對帳錯誤發生率與時間成本，同時向參賽者推播繳費完成訊息與更新院校後台表單狀態。
  p 當貴校啟用本系統服務時，即表示貴校已詳細閱讀並明確瞭解且同意接受以下條款內容：
  ol
    li(v-for='(term, index) in terms' :key='index') {{ term }}
</template>

<script>
export default {
  name: 'PaymentTerms',
  data () {
    return {
      terms: [
        '金流系統合作院校並須前往【設定】→【帳務】，設定匯款帳戶資訊，並於【組別規則】設置各組別報名費用。',
        '承前項，若該組別免報名費用，須將報名費用設置為 NT$0。',
        '總報名款項為有效報名表單款項之總和，亦即不包含經由系統辦理退賽之表單。',
        '總報名款項將會於「報名截止」後 3~5 個工作天內匯入乙方帳戶，其款項已扣除手續費用及現場繳費費用。',
        '參賽者以現場繳費之方式進行付款後，乙方須至【報名表單】手動設置該表單繳費狀態，此操作行為不可逆，乙方須承擔該表單金流後續保證及責任。',
        '參賽者以轉帳至 ATM 虛擬帳戶之方式進行付款，且單次報名將產生 NT$15 手續費用，亦即會從各組所設定之金額中再另外扣除手續費用。',
        '有效繳費期限為 3 天，逾期則視作未報名，參賽者須重新填寫報名表單。',
        '若參賽者於繳費後 1 個工作天反映未收到繳費完成通知以及繳費狀態更新，乙方需提供參賽者報名表單資訊與匯款收據於甲方，此時甲方列入「轉帳失敗」案例處理並需義務協助乙方查核之。',
        '甲方依照綠界科技 EC Pay 作為參賽者繳費狀態主要憑據，「轉帳失敗」狀態依照合約附件說明。',
        '若參賽者於「報名截止」前棄賽，甲方將會退還報名費用之 50% 並扣除手續費 $15，反之則不予退費。',
        '退款時間為該院校「報名截止」後 3~14 個工作天內，甲方自動將款項退入參賽者填寫之帳戶資訊。',
        '退賽之退款事宜由甲方辦理，若乙方私下退款造成總匯款金額錯誤，甲方無須承擔任何責任。',
        '「流音之星」、「淡江金韶獎」因賽制規章規定，系統將不予退還任何報名費用。',
        '「高科大弦音盃」因賽制規章規定，報名截止後，系統將不予退還任何報名費用。',
        '「政大金旋獎」因賽制規章規定，有關退費與棄賽之條約內容（10、11、12點）由政大金旋獎自行處理，甲方不需作出任何保證或承擔任何責任。',
        '若金流系統合作院校欲將規定調整為「不予退還報名費用」，請聯繫樂台計畫官方人員。',
        '第 7 點至第 16 點，為 ATM 虛擬帳戶之方式進行付款之前提成立。',
        '金流合作院校之非經過綠界科技 EC Pay 所完成之繳費行為，甲方不會作出任何保證或承擔任何責任。',
        '非金流系統合作院校相關繳費問題，甲方不會作出任何保證或承擔任何責任。',
        '非金流系統合作院校如需開啟金流系統服務，請聯繫甲方。',
      ],
    }
  },
}
</script>

<style scoped lang="sass">
section
  margin-bottom: 1rem
.head
  margin-bottom: 1rem
ol li
  margin-bottom: .5rem
</style>
